import React from "react";
import ClaimAwardSummaryTable from "./ClaimAwardSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const ClaimAwardSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={ClaimAwardSummaryTable}
    loadingMessage="Loading claim award summary..."
  />
);

export default ClaimAwardSummaryIndex;
